// extracted by mini-css-extract-plugin
export default {"mainBody":"index_mainBody_nw5go","cmt_past":"index_cmt_past_E8qGA clearfix","cmtBox":"index_cmtBox_EWjsw","footer":"index_footer_baO3z"};